// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PlAW","newExpiryDate":"styles_newExpiryDate__2dg2W","footer":"styles_footer__2DRjQ"};